import { render, staticRenderFns } from "./judgeList.vue?vue&type=template&id=0d3ff16c&"
import script from "./judgeList.vue?vue&type=script&lang=js&"
export * from "./judgeList.vue?vue&type=script&lang=js&"
import style0 from "./judgeList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports